import { api_GET, api_POST } from "./_api.js";

const fiscalizacaoInfracaoDividaAtiva_api = {
    GetBoletoSolicitacaoInscricaoDividaAtiva: (fiscalizacaoInfracao_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoInfracaoDividaAtiva/GetBoletoSolicitacaoInscricaoDividaAtiva/${fiscalizacaoInfracao_Id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetFichaSolicitacaoInscricaoDividaAtiva: (fiscalizacaoInfracao_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoInfracaoDividaAtiva/GetFichaSolicitacaoInscricaoDividaAtiva/${fiscalizacaoInfracao_Id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getList: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`FiscalizacaoInfracaoDividaAtiva/GetList`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postInscreverDividaAtiva: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`FiscalizacaoInfracaoDividaAtiva/InscreverDividaAtiva`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postBaixaDividaAtiva: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`FiscalizacaoInfracaoDividaAtiva/BaixaDividaAtiva`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default fiscalizacaoInfracaoDividaAtiva_api;
